exports.f = {}.propertyIsEnumerable;
